export const PACKAGE_LOADING = "PACKAGE_LOADING";
export const PACKAGE_ERROR = "PACKAGE_ERROR";
export const PACKAGE_GET_LIST = "PACKAGE_GET_LIST";
export const PACKAGE_RESET_LIST = "PACKAGE_RESET_LIST";
export const PACKAGE_ADD = "PACKAGE_ADD";
export const PACKAGE_ADD_IMAGE = "PACKAGE_ADD_IMAGE";
export const PACKAGE_GET_IMAGE = "PACKAGE_GET_IMAGE";
export const PACKAGE_GET_UNITS_OF_MEASUREMENT = "PACKAGE_GET_UNITS_OF_MEASUREMENT";
export const PACKAGE_ASSIGN_TO_USERS_LIST = "PACKAGE_ASSIGN_TO_USERS_LIST";



// WEBPACK FOOTER //
// ./src/actions/package/constants.js